var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[(_vm.loading)?_c('span',{staticClass:"loading text-center"},[_c('i',{staticClass:"far fa-pulse fa-spinner"})]):_vm._e(),(_vm.member)?_c('span',[_vm._v(_vm._s(_vm.member.name_first)+" "+_vm._s(_vm.member.name_last))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }